<template>
  <div class="recommended-articles" v-if="articles.length > 0">
    <h2 class="recommended-articles__heading">{{ headerText }}</h2>
    <section class="recommended-articles__list">
      <article v-for="article in articles" :key="article.id" class="recommended-article">
        <a class="recommended-article__link" :href="article.url" target="_blank">
          <img class="recommended-article__image" :src="article.image" :alt="article.imageAlt"/>
          <div class="recommended-article__group">
            <span class="recommended-article__header">
              {{article.header}}
            </span>
            <span class="recommended-article__subheader">{{article.subheader}}</span>
          </div>
        </a>
      </article>
    </section>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue
} from 'vue-property-decorator';
import Article from '../../models/Article';

@Component
export default class RecommendedArticlesComponent extends Vue {
  @Prop()
  public recommendedArticles!: Article[];

  public get articles(): Article[] {
    if (!this.recommendedArticles) {
      return [];
    }

    return this.recommendedArticles.splice(0, 2);
  }

  @Prop({ default: 'You may also be interested in' })
  public headerText!: string;
}
</script>
